// Reusable function to convert title to kebab-case
export const convertToKebabCase = (title: string) => {
	return title
		?.toLowerCase()
		.replace(/æ/g, 'ae')
		.replace(/ø/g, 'oe')
		.replace(/å/g, 'aa')
		.replace(/[^a-z0-9\s-]/g, '') // Retain letters, numbers, spaces, and dashes
		.replace(/\s+/g, '-') // Replace spaces with a single dash
		.replace(/-+/g, '-') // Collapse multiple consecutive dashes into one
		.replace(/^-+|-+$/g, ''); // Remove leading or trailing dashes
};

// Function to handle navigation
export const handleNavigation = (title: string, policyNumber: string, navigate: any) => {
	const kebabCaseTitle = convertToKebabCase(title); // Using the reusable function
	navigate(`/forsikringer/${kebabCaseTitle}?id=${policyNumber}`);
};

// Function to create navigation URL
export const createNavigation = (title: string, policyNumber: string) => {
	const kebabCaseTitle = convertToKebabCase(title); // Using the reusable function
	return `/forsikringer/${kebabCaseTitle}?id=${policyNumber}`;
};

// Function to render the appropriate icon based on the policy type
export const getPolicyIcon = (type: string) => {
	switch (type?.toLowerCase()) {
		case 'car':
			return '/icons/car-icon.svg'; // Replace with appropriate image path or URL
		case 'home':
			return '/icons/home-icon.svg'; // Replace with appropriate image path or URL
		case 'travel':
			return '/icons/travel-icon.svg'; // Replace with appropriate image path or URL
		default:
			return '/icons/default-icon.svg'; // Replace with appropriate image path or URL
	}
};

// Helper function to find the matching icon URL from mainArea
export const findIconUrl = (policyTitle: string, mainArea: { items: any[] }) => {
	const element = document.getElementById('app');
	const domainUrl = element?.getAttribute('data-domain') ?? '';

	// Convert the policyTitle to kebab-case before comparison
	const kebabCaseTitle = convertToKebabCase(policyTitle);

	const matchingItem = mainArea.items.find(
		(item: { content: { title: string } }) => kebabCaseTitle.includes(convertToKebabCase(item.content.title)) // Convert item title to kebab-case for comparison
	);

	return (
		matchingItem?.content.icon.url || domainUrl + '/codan/codan-media/icons-svg/products/icon-product_fabrik.svg'
	);
};
